import { desktopscreensize } from '../../../../utilities/constants';

export const handleDropDownState = (e: any, currentDetails: any) => {
  currentDetails.handleNavFunctions.handleDropDownState(e);
};

export const handleReRoutingAndDropDownState = (
  e: any,
  currentDetails: any
) => {
  currentDetails.widthwindow < desktopscreensize
    ? currentDetails.handleNavFunctions.handleReRouting(e)
    : handleDropDownState(e, currentDetails);
};
